import { OFFER_TYPE } from '../../../../../../views/menu/offers/constants';

export default {
  [OFFER_TYPE.BOGO]: '1 acheté, 1 offert',
  [OFFER_TYPE.FREE_ITEM]: 'Article gratuit',
  [OFFER_TYPE.AMOUNT_OFF]: 'Montant réduit',
  [OFFER_TYPE.PERCENTAGE_OFF]: 'Pourcentage de réduction',
};
